interface SkeletonItemProps {
    gridSpan?: number;
    width?: number;
    flex?: number;
    height: number;
}

const SkeletonItem = ({ gridSpan, width, height, flex }: SkeletonItemProps) => {
    const style: any = { overflow: 'hidden', position: 'relative' };
    if(gridSpan) style.gridColumn = `span ${gridSpan}`;
    if(width) style.width = width;
    if(flex) style.flex = flex;
    if(height) style.minHeight = height;

    return <div className="skeleton-item" style={style}>
        <div className="shiny"/>
    </div>

}

export default SkeletonItem;